import styled from 'styled-components/macro';

const SidebarList = styled(({className, children}) => (
    <div className={className}>
        {children}
    </div>
))`
  margin-bottom: 16px;
`;

export default SidebarList;
